import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import Strategicreporting from "../../Assests/1.svg";
import AdaptiveInterface from "../../Assests/4.svg";
import reporting from "../../Assests/Frame 2147225072.svg";
import tymeplusAI from "../../Assests/Frame 2147225074.svg";
import adaptiveinterface from "../../Assests/Frame 2147225075.svg";
import productivity from "../../Assests/Frame 564.svg";
import Integration from "../../Assests/Integration.svg";
import TymeplusAI from "../../Assests/Tymeplus AI.svg";
import integration from "../../Assests/Web inte.svg";
import Personalized from "../../Assests/Your personalized.svg";
import CircleConnector from "./CircleStepper";
import FeatureWrap from "./style";
import ImageThree from "../../../src/Assests/trackright/imageThree.svg";
import { Col, Row } from "antd";
import ProductTimeline, { OurProducts } from "./Product";
import ProductRow from "./Fleethardwaresection";
import ProductSection from "./Product";


const steps = [
  {
    id: 0,
    label: "TrackRight AI",
    description: `TrackRight AI  is an intelligent  IOT AI-driven logistics system focused on delivery management, trip analysis, route optimization, real time trip monitoring  and carbon footprint visibility. It’s built to improve efficiency in daily delivery operations and embraces sustainability.`,
    image: `${ImageThree}`,
    mobimg: `${Strategicreporting}`,
  },
  {
    id: 1,
    label: "TrackRight AI Cargo",
    description:
      "TrackRight AI Cargo is an IOT driven AI-powered logistics software designed to optimize first-mile & last-mile for shipping containers/ containerized cargo embracing sustainably.",
    image: `${ImageThree}`,
    // mobimg: `${Personalized}`,
  },
  // {
  //   id: 2,
  //   label: "TrackRight AI 1.O",
  //   description: `With our Al technology, accessing information has never been easier. Whether you're a manager looking for real-time insights or an employee seeking answers to your queries, our Al-powered assistant has you covered.`,
  //   image: `${ImageThree}`,
  //   mobimg: `${TymeplusAI}`,
  // },
  {
    id: 2,
    label: "TrackRight AI+",
    description: `TrackRight AI Plus is an AI-powered logistics platform designed to optimize supply chain operations, specifically focusing on first-mile, last-mile, and e-commerce deliveries. The software utilizes artificial intelligence to automate routing and real-time tracking, which has proven to increase business profitability by up to 17% while reducing fuel consumption by 20%.`,
    image: `${ImageThree}`,
    // mobimg: `${AdaptiveInterface}`,
  },
  {
    id: 3,
    label: "EcoSecure",
    description: `EcoSecure is a smart vehicle and fleet security tracking solution designed to help businesses monitor, protect, and optimize their vehicles in real time—while also promoting safer driving and environmental responsibility.`,
    image: `${integration}`,
    // mobimg: `${Integration}`,
  },
];

const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundImage:
    "linear-gradient( 136deg, #2d53da 0%, #2d53da 50%,white 100%)",
  zIndex: 1,
  color: "#fff",
  width: 40,
  height: 40,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  opacity: 0.3,
  ...(ownerState.active && {
    backgroundImage:
      "linear-gradient( 136deg, #2d53da 0%, #2d53da 50%,white 100%)",
    boxShadow: "0 4px 40px 0 #2d53da",
    width: 50,
    height: 50,
    opacity: 1,
  }),
  ...(ownerState.completed && {
    backgroundImage:
      "linear-gradient( 136deg, #2d53da 0%, #2d53da 50%,white 100%)",
  }),
}));

function ColorlibStepIcon(props) {
  const { active, completed, className } = props;

  return (
    <ColorlibStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    />
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  completed: PropTypes.bool,
  icon: PropTypes.node,
};

export const Features = ({
  setColor = false,

  isHRManagementVisible,
}) => {
  const featuresRef = useRef(null);
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    const sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setColor(true);
          } else {
            // setColor(false);
          }
        });
      },
      { threshold: 0.5 },
    );
    if (featuresRef.current) {
      sectionObserver.observe(featuresRef.current);
    }

    return () => {
      if (featuresRef.current) {
        sectionObserver.unobserve(featuresRef.current);
      }
    };
  }, [featuresRef]);

  return (
    <>
  <ProductSection/>
  <ProductRow/>
    </>
  );
};

export default Features;
    // <FeatureWrap>
    //     <section
    //       className="py-4 mb-4 feature-component"
    //       id="our_product_section"
    //       ref={featuresRef}
    //     >
    //       <div className="ps-5 mobilestepper-contain">
    //         <h3
    //           className="text4 underline contain-margin"
    //           style={{ color: "white", fontSize: "24px" }}
    //         >
    //           <span className="underline">Our</span> &nbsp;Products
    //         </h3>
    //         <Row>
    //           <Col xl={18}>
    //             <CircleConnector
    //               steps={steps}
    //               activeStep={activeStep}
    //               setActiveStep={setActiveStep}
    //               isHRManagementVisible={isHRManagementVisible}
    //             />
    //           </Col>
    //           <Col xl={6}>
    //             <img className="sticky" src={ImageThree} alt="ImageThree" />
    //           </Col>
    //         </Row>
    //       </div>
    //     </section>
    //   </FeatureWrap>